/**
 * @file  open-sdk的公共常量 （Public API）
 * 此文件中的 export 将对外部项目可见，请勿添加仅用于 SDK 内部的常量。
 * @public
 */
// 插件执行失败错误码
export const PLUGIN_EXECUTE_ERROR = {
    OTHER: 17004, // 开放平台服务调用失败
    UNKNOWN: 17005, // 未知错误
    CODE: 17006, // 代码有误，请联系开发者
    VIP_EXPIRE: 17008, // 版本过期
    UNINSTALL: 17009, // 插件已卸载
    DISABLED: 17010, // 插件已停用
    PARAMS: 17020, // 插件入参不合法
    CUSTOM: 17021, // 开发者自定义错误
    COIN_RECHARGE: 17035, // 云币余额不足
    COIN_REQUIRED: 17036, // 未开启云币支付
    WRONG_CONFIG: 17045, // 请检查插件配置
    EXPIRE: 17046, // 插件版本过期
    FUNCTION_DELETED: 17055, // 函数被删除
    CONTACT_EXCEED: 17056, // 入参成员/部门/角色数量超限
    /** runtime不合法 */
    RUNTIME: 17057
};
